import toast from "react-hot-toast";
import Button from "./Button";

const CustomToast = ({ actions = null, message, visible = true }) => {
  const handleLinkAndButtonsClick = (event) => {
    const target = event.target;
    if (target.closest("button") || target.closest("a")) {
      toast.dismiss();
    }
  };

  const handleCloseClick = () => {
    toast.dismiss();
  };

  return (
    <div
      onClick={handleLinkAndButtonsClick}
      className={`color-bg-white p-3 drop-shadow border-radius ${
        visible ? "animate-enter" : "animate-leave"
      } `}
    >
      <div className="d-flex flex-column gap-3 position-relative">
        <Button
          icon="close"
          iconSize="small"
          onClick={handleCloseClick}
          className="position-absolute top-0 end-0"
        />
        <div className="fs-7 me-4">{message}</div>
        <div className="toast-actions d-flex gap-3">{actions}</div>
      </div>
    </div>
  );
};

export default CustomToast;
